import { defineMessage } from "react-intl";

/* Rental area states */
export const RENTAL_AREA_STATES_VALUE_ENABLED = "enabled";
export const RENTAL_AREA_STATES_VALUE_DISABLED = "disabled";

export const RENTAL_AREA_STATES = {
  [RENTAL_AREA_STATES_VALUE_ENABLED]: {
    id: RENTAL_AREA_STATES_VALUE_ENABLED,
    label: defineMessage({ defaultMessage: "activer" }),
    colors: ["green.600", "green.300"],
    color: "green",
  },
  [RENTAL_AREA_STATES_VALUE_DISABLED]: {
    id: RENTAL_AREA_STATES_VALUE_DISABLED,
    label: defineMessage({ defaultMessage: "désactiver" }),
    colors: ["purple.600", "purple.300"],
    color: "purple",
  },
};

export const RENTAL_AREA_STATES_LIST = Object.values(RENTAL_AREA_STATES);

/* Rental area sorts */
export const RENTAL_AREA_SORT_CREATED_ASC = "created_asc";
export const RENTAL_AREA_SORT_CREATED_DESC = "created_desc";
export const RENTAL_AREA_SORT_NAME_ASC = "name_asc";
export const RENTAL_AREA_SORT_NAME_DESC = "name_desc";
export const RENTAL_AREA_SORT_POSITION_ASC = "position_asc";
export const RENTAL_AREA_SORT_POSITION_DESC = "position_desc";

export const RENTAL_AREA_SORTS = {
  [RENTAL_AREA_SORT_CREATED_ASC]: {
    id: RENTAL_AREA_SORT_CREATED_ASC,
    label: defineMessage({ defaultMessage: "date de création croissante" }),
  },
  [RENTAL_AREA_SORT_CREATED_DESC]: {
    id: RENTAL_AREA_SORT_CREATED_DESC,
    label: defineMessage({ defaultMessage: "date de création décroissante" }),
  },
  [RENTAL_AREA_SORT_NAME_ASC]: {
    id: RENTAL_AREA_SORT_NAME_ASC,
    label: defineMessage({ defaultMessage: "alias A ⇨ Z" }),
  },
  [RENTAL_AREA_SORT_NAME_DESC]: {
    id: RENTAL_AREA_SORT_NAME_DESC,
    label: defineMessage({ defaultMessage: "alias Z ⇨ A" }),
  },
  [RENTAL_AREA_SORT_POSITION_ASC]: {
    id: RENTAL_AREA_SORT_POSITION_ASC,
    label: defineMessage({ defaultMessage: "position croissante" }),
  },
  [RENTAL_AREA_SORT_POSITION_DESC]: {
    id: RENTAL_AREA_SORT_POSITION_DESC,
    label: defineMessage({ defaultMessage: "position décroissante" }),
  },
};

export const RENTAL_AREA_SORTS_LIST = Object.values(RENTAL_AREA_SORTS);

/* Rental area booking_interval unité */
export const RENTAL_AREA_BOOKING_INTERVAL_UNIT_MINUTES = "minutes";
export const RENTAL_AREA_BOOKING_INTERVAL_UNIT_HOURS = "hours";
export const RENTAL_AREA_BOOKING_INTERVAL_UNIT_DAYS = "days";

export const RENTAL_AREA_BOOKING_INTERVAL_UNITS = {
  [RENTAL_AREA_BOOKING_INTERVAL_UNIT_MINUTES]: {
    id: RENTAL_AREA_BOOKING_INTERVAL_UNIT_MINUTES,
    label: defineMessage({ defaultMessage: "minutes" }),
    maxValue: 60,
  },
  [RENTAL_AREA_BOOKING_INTERVAL_UNIT_HOURS]: {
    id: RENTAL_AREA_BOOKING_INTERVAL_UNIT_HOURS,
    label: defineMessage({ defaultMessage: "heures" }),
    maxValue: 24,
  },
  [RENTAL_AREA_BOOKING_INTERVAL_UNIT_DAYS]: {
    id: RENTAL_AREA_BOOKING_INTERVAL_UNIT_DAYS,
    label: defineMessage({ defaultMessage: "jours" }),
    maxValue: 31,
  },
};

export const RENTAL_AREA_BOOKING_INTERVAL_UNITS_LIST = Object.values(
  RENTAL_AREA_BOOKING_INTERVAL_UNITS,
);
